import styled from "@emotion/styled";
import { theme } from "@styles/theme";
const { sm, md, lg } = theme.breakpoints;

export const Container = styled.div`
  background-color: #f3f5f7;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;
export const Content = styled.div`
  width: 80%;
  margin: 0 auto;
  flex-grow: 1;
  @media (max-width: ${lg}) {
    font-size: 12px;
    width: 90%;
  }
  @media (max-width: ${md}) {
    font-size: 14px;
  }
  @media (max-width: ${sm}) {
    width: 100%;
  }
`;
